export type BdHelpButtonColor = 'primary' | 'accent' | 'warn';

export interface BdHelpButtonOptions {
  mode: 'button' | 'toolbar' | 'other';
  hexColor?: string;
  color?: BdHelpButtonColor;
}

export const BD_HELP_BUTTON_OPTIONS_DEFAULT: BdHelpButtonOptions = {
  mode: 'button',
  color: 'accent'
};

export const BD_HELP_BUTTON_OPTIONS_TOOLBAR: BdHelpButtonOptions = {
  mode: 'toolbar'
};
